export const BROWSER_NAME = {
  SAFARI: 'Safari',
  MOBILE_SAFARI: 'Mobile Safari'
}
